import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) =>
  ({
    activeProfileElements: state.activeProfileElements
  });

class ProfileElementField extends React.Component {
  constructor(props){
    super(props);
    this.state = {}
  }

  render(){
    return (
      <div>{this.props.activeProfileElements.includes(this.props.elementName) ? this.props.childComponent : null}</div>
    );
  }

};

export default connect(mapStateToProps)(ProfileElementField)
